import { render } from "./SeguradoForm.vue?vue&type=template&id=f3f77ed6"
import script from "./SeguradoForm.vue?vue&type=script&lang=js"
export * from "./SeguradoForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__